import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import "./../Styles/transaction.css"; // Imports the CSS above

export default function Transaction() {
  const [transactions, setTransactions] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddModal, setShowAddModal] = useState(false);

  const [manualPayment, setManualPayment] = useState({
    mobile: "",
    amount: "",
    payment_mode: "Cash",
    txnid: "",
    days: 30,
  });
  const itemsPerPage = 30;

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  useEffect(() => {
    if (user?.id) {
      fetchTransactions();
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [fromDate, toDate, statusFilter, typeFilter]);

  const fetchTransactions = async () => {
    try {
      const res = await fetch(
        `${API.BASE_URL}/payment.php?action=all_payment_transactions`,
      );

      const data = await res.json();

      const workRes = await fetch(
        `${API.BASE_URL}/payment.php?action=all_work_payment_transactions`,
      );

      const workData = await workRes.json();

      const normalTransactions = data.status ? data.data : [];

      const workPayments = workData.status
        ? workData.data.map((item) => ({
            ...item,
            transaction_type: "Work Payment",
            status:
              item.payment_status === "Paid" ? "Success" : item.payment_status,
            payment_mode: "Razorpay",
            txnid: item.txnid,
            name: item.name || "-",
            phone: item.phone || "-",
          }))
        : [];

      const allTransactions = [...normalTransactions, ...workPayments].sort(
        (a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        },
      );

      setTransactions(allTransactions);
    } catch (err) {
      console.log(err);
    }
  };
  const filteredTransactions = transactions.filter((item) => {
    const itemDate = new Date(item.created_at);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    const statusMatch = statusFilter ? item.status === statusFilter : true;
    const typeMatch = typeFilter ? item.transaction_type === typeFilter : true;
    const fromMatch = from ? itemDate >= from : true;
    const toMatch = to ? itemDate <= to : true;

    return statusMatch && typeMatch && fromMatch && toMatch;
  });

  const paginatedData = filteredTransactions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const statusColor = (status) => {
    status = String(status).toLowerCase();

    if (status === "success" || status === "paid") return "#d1fae5";

    if (status === "failed" || status === "cancelled") return "#fee2e2";

    return "#fef3c7";
  };

  const textColor = (status) => {
    status = String(status).toLowerCase();

    if (status === "success" || status === "paid") return "#065f46";

    if (status === "failed" || status === "cancelled") return "#991b1b";

    return "#92400e";
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const typeStyle = (type) => {
    switch (type) {
      case "Design Order":
        return { background: "#dbeafe", color: "#1d4ed8" };
      case "Machine Ads":
        return { background: "#dcfce7", color: "#15803d" };
      case "Workspace Ads":
        return { background: "#ede9fe", color: "#7c3aed" };
      case "Server Charge":
        return { background: "#fff7ed", color: "#ea580c" };
      case "Work Payment":
        return {
          background: "#fef3c7",
          color: "#b45309",
        };
      default:
        return { background: "#f3f4f6", color: "#374151" };
    }
  };
  const saveManualPayment = async () => {
    if (!manualPayment.mobile) {
      alert("Enter Mobile Number");
      return;
    }

    if (!manualPayment.amount) {
      alert("Enter Amount");
      return;
    }

    try {
      const payload = {
        mobile: manualPayment.mobile,

        amount: manualPayment.amount,

        payment_mode: manualPayment.payment_mode,

        txnid: manualPayment.txnid,

        days: manualPayment.days,
      };

      const res = await fetch(
        `${API.BASE_URL}/api.php?action=add_manual_server_charge`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      alert(data.message);

      if (data.status) {
        setShowAddModal(false);

        fetchTransactions();

        setManualPayment({
          mobile: "",

          amount: "",

          payment_mode: "Cash",

          txnid: "",

          days: 30,
        });
      }
    } catch (error) {
      console.log(error);

      alert("Server error");
    }
  };

  const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage) || 1;

  return (
    <div className="container-fluid px-4 py-4 txn-page-container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold txn-page-heading">Transaction History</h4>

        <button
          className="btn btn-primary"
          onClick={() => setShowAddModal(true)}
        >
          <i className="bi bi-plus-circle me-2"></i>
          Add Server Charge
        </button>
      </div>
      {/* Filter Bar */}
      <div className="d-flex align-items-end gap-3 flex-wrap mb-4 p-3 txnp-filter-bar">
        <div>
          <label className="form-label mb-1 txnp-filter-label">From</label>
          <input
            type="date"
            className="form-control txnp-form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label className="form-label mb-1 txnp-filter-label">To</label>
          <input
            type="date"
            className="form-control txnp-form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div>
          <label className="form-label mb-1 txnp-filter-label">Status</label>
          <select
            className="form-select txnp-form-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All</option>
            <option value="Success">Success</option>
            <option value="Failed">Failed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        <div>
          <label className="form-label mb-1 txnp-filter-label">Type</label>
          <select
            className="form-select txnp-form-select"
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
          >
            <option value="">All Types</option>
            <option value="Design Order">Design Order</option>
            <option value="Machine Ads">Machine Ads</option>
            <option value="Workspace Ads">Workspace Ads</option>
            <option value="Server Charge">Server Charge</option>
            <option value="Work Payment">Work Payment</option>
          </select>
        </div>

        <div>
          <button
            className="btn txnp-btn-clear"
            onClick={() => {
              setFromDate("");
              setToDate("");
              setStatusFilter("");
              setTypeFilter("");
            }}
          >
            Clear
          </button>
        </div>
      </div>

      {/* Main Table Card */}
      <div className="card txnp-card p-0 mb-0">
        <div className="card-body p-0 w-100">
          <div className="table-responsive p-0 mb-0">
            <table className="table align-middle txnp-table">
              <thead className="txnp-table-head">
                <tr>
                  <th>#</th>
                  <th>Date & Time</th>
                  <th>Type</th>
                  <th>Customer</th>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                  <th>Mode</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-5">
                      No transactions found
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, index) => (
                    <tr
                      key={`${item.transaction_type}-${item.id}`}
                      className="txnp-table-row"
                    >
                      <td>{filteredTransactions.length - index}</td>
                      <td>
                        <div className="txnp-text-primary-val">
                          {formatDate(item.created_at)}
                        </div>
                        <div className="txnp-text-subtle">
                          {formatTime(item.created_at)}
                        </div>
                      </td>

                      <td>
                        <span
                          className="txnp-type-pill"
                          style={typeStyle(item.transaction_type)}
                        >
                          {item.transaction_type}
                        </span>
                      </td>

                      <td>
                        <div className="txnp-text-primary-val">
                          {item.name || "-"}
                        </div>
                        <div className="txnp-text-subtle">
                          {item.phone || "-"}
                        </div>
                      </td>

                      <td className="txnp-txnid-code">{item.txnid || "-"}</td>

                      <td className="txnp-amount-val">
                        ₹{Number(item.amount).toLocaleString("en-IN")}
                      </td>
                      <td>{item.payment_mode || "Razorpay"}</td>
                      <td>
                        <span
                          className="txnp-status-pill"
                          style={{
                            background: statusColor(item.status),
                            color: textColor(item.status),
                          }}
                        >
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="txnp-pagination-bar">
            <button
              className="txnp-pagination-btn"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span className="txnp-pagination-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="txnp-pagination-btn"
              onClick={() =>
                setCurrentPage((p) => (p < totalPages ? p + 1 : p))
              }
              disabled={currentPage >= totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {showAddModal && (
        <div className="scp-modal-overlay">
          <div className="scp-modal-box">
            <div className="scp-modal-header">
              <h4>Add Server Charge Payment</h4>
            </div>

            <div className="scp-form-group">
              <label>Mobile Number</label>

              <input
                type="text"
                className="scp-input"
                placeholder="Enter Mobile Number"
                value={manualPayment.mobile}
                onChange={(e) =>
                  setManualPayment({
                    ...manualPayment,
                    mobile: e.target.value,
                  })
                }
              />
            </div>

            <div className="scp-form-group">
              <label>Amount</label>

              <input
                type="number"
                className="scp-input"
                placeholder="Enter Amount"
                value={manualPayment.amount}
                onChange={(e) =>
                  setManualPayment({
                    ...manualPayment,
                    amount: e.target.value,
                  })
                }
              />
            </div>

            <div className="scp-form-group">
              <label>Payment Mode</label>

              <select
                className="scp-select"
                value={manualPayment.payment_mode}
                onChange={(e) =>
                  setManualPayment({
                    ...manualPayment,
                    payment_mode: e.target.value,
                  })
                }
              >
                <option>Cash</option>
                <option>Google Pay</option>
                <option>PhonePe</option>
                <option>Paytm</option>
                <option>Cheque</option>
              </select>
            </div>

            <div className="scp-form-group">
              <label>Transaction No.</label>

              <input
                type="text"
                className="scp-input"
                placeholder="Enter Transaction Number"
                value={manualPayment.txnid}
                onChange={(e) =>
                  setManualPayment({
                    ...manualPayment,
                    txnid: e.target.value,
                  })
                }
              />
            </div>

            <div className="scp-form-group">
              <label>Validity (Days)</label>

              <input
                type="number"
                className="scp-input"
                placeholder="Enter Validity Days"
                value={manualPayment.days}
                onChange={(e) =>
                  setManualPayment({
                    ...manualPayment,
                    days: e.target.value,
                  })
                }
              />
            </div>

            <div className="scp-modal-actions">
              <button
                type="button"
                className="scp-save-btn"
                onClick={saveManualPayment}
              >
                Save Payment
              </button>

              <button
                type="button"
                className="scp-cancel-btn"
                onClick={() => setShowAddModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
